import { PropsWithChildren } from 'react';
import { ErrorBoundary } from './ErrorBoundry';

export function AppLayout({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary>
      <div className="bg-white min-h-screen flex flex-col pb-[20vh]">
        {children}
      </div>
    </ErrorBoundary>
  );
}
